import classNames from 'classnames';

import ConditionalInput from '../ConditionalInput';
import React from 'react';
import styled from 'styled-components';
import { Radio } from '@mantine/core';

export const Substitute = ({
  item,
  onChangeElseValue,
  onChangeThen,

  onChangeColumnsCount,
  onChangeUpdateType,
  filterTypes
}) => {
  const filterTypeId = filterTypes?.[0]?.id;
  return (
    <div id="grid-table-substitute-root" className="">
      <div
        id="grid-table-substitute-card"
        className={classNames('filter_card', {
          ['noBorderTop']: true,
          ['isDisableBefore']: true
        })}
      >
        <div id="grid-table-substitute-content" className="filter_content">
          <WrapperFlex id="grid-table-substitute-row" className="form-element">
            <div id="grid-table-substitute-old">
              <Label id="grid-table-substitute-old-label">
                Old Text<span className="required">*</span>
              </Label>

              <ConditionalInput
                id="grid-table-substitute-old-input"
                hiddenVariants={['column', 'null', 'input', 'ai_input']}
                type="input"
                value={item.elseValue.input}
                hasRequiredError={item.errors?.includes('elseValue')}
                onChangeValue={val => onChangeElseValue(filterTypeId, item?.id, val)}
                containerProps={{
                  style: {
                    width: 250
                  }
                }}
              />
            </div>

            <div id="grid-table-substitute-new">
              <Label id="grid-table-substitute-new-label">New Text</Label>

              <ConditionalInput
                id="grid-table-substitute-new-input"
                hiddenVariants={['column', 'null', 'input', 'ai_input']}
                type="input"
                value={item.then.input}
                onChangeValue={val => onChangeThen(filterTypeId, item?.id, val)}
                containerProps={{
                  style: {
                    width: 250
                  }
                }}
              />
            </div>
          </WrapperFlex>

          <div id="grid-table-substitute-limits" className="form-element">
            <Wrapper id="grid-table-substitute-limits-wrapper">
              <WrapperFlex id="grid-table-substitute-limits-row" style={{ marginBottom: '8px' }}>
                <Label id="grid-table-substitute-limits-label">
                  Maximum number of replacements
                </Label>

                <WrapperFlex>
                  <Radio
                    id="grid-table-substitute-input-radio"
                    size="xs"
                    checked={item.updateType === 'input'}
                    isChecked={item.updateType === 'input'}
                    onClick={() => onChangeUpdateType(filterTypeId, item?.id, 'input')}
                    label="Input"
                  />

                  <Radio
                    id="grid-table-substitute-all-radio"
                    size="xs"
                    checked={item.updateType === 'all'}
                    isChecked={item.updateType === 'all'}
                    onClick={() => onChangeUpdateType(filterTypeId, item?.id, 'all')}
                    label="All"
                  />
                </WrapperFlex>
              </WrapperFlex>

              <ConditionalInput
                id="grid-table-substitute-count-input"
                hiddenVariants={['column', 'null', 'input', 'ai_input']}
                type="input"
                inputType="number"
                disabled={item.updateType === 'all'}
                value={item.columnsCount}
                onChangeValue={val => onChangeColumnsCount(filterTypeId, item?.id, val)}
                containerProps={{
                  style: {
                    width: '48.5%'
                  }
                }}
              />
            </Wrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

const Label = styled.label`
  font-weight: 600;
  margin-bottom: 0 !important;

  &.error {
    color: red;
  }
`;

const Wrapper = styled.div`
  margin-top: 10px;
`;

const WrapperFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  gap: 15px;
`;
